export default {
	pageName: "ViewGroup",

	pageWrapperSpacing: 20,
	menuWidth: 200,
	spacingMenuToScreen: 20,
};
